import angular, { ICompileService } from "angular";
import { RecordDataSource } from "../../../../records/grids";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { FilterProvider } from "../../../../records/grids/columns/filters/FilterProvider";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import { OptionsFilter } from "../../../../records/grids/columns/filters/subFilters/OptionsFilter";
import { MachineConfigurationSoftwareView } from "../../models/machineConfiguration";
import {
  MachineConfigurationCellClassService,
  vsServiceName as MachineConfigurationCellClassServiceName,
} from "../../../shared/machineConfigurationCellClassService";
export interface IMultipleMoveFormModel {
  MachinesDetails: IMachineSoftwareUpgradeRequest[];
  Date?: Date;
  Files: File[];
  Notes?: string;
}

export interface IMachineSoftwareUpgradeRequest {
  MachineId: number;
  MachineBankId?: number;
  MachineConfigurationPosition?: string;
  SerialNumber: string;
  PropertyId?: number;
  PropertyName?: string;
  MachineAreaId?: number;
  MachineAreaName?: string;
  MachineZoneId?: number;
  MachineZoneName?: string;
  MachineBankName?: string;
  PreviousPropertyName?: string;
  PreviousMachineAreaName?: string;
  PreviousMachineZoneName?: string;
  PreviousMachineBankName?: string;
  PreviousPosition?: string;
}

const gridId = Symbol("main.machines.software");
export class MachinesSoftwareViewController {
  static $inject = [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$compile",
    "$state",
    "environment",
    "$uibModal",
    MachineConfigurationCellClassServiceName,
  ];

  readonly gridDataSource: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery;

  private gridSelection: MachineConfigurationSoftwareView[] = [];

  currentOrFutureConfigurationsOnly: boolean = true;
  selectedOnly: boolean = false;

  constructor(
    serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    $compile: ICompileService,
    private readonly $state: any,
    private readonly environment: { Date: Date },
    private readonly $uibModal: angular.ui.bootstrap.IModalService,
    machineConfigurationCellClassService: MachineConfigurationCellClassService
  ) {
    this.defaultQuery = {
      CurrentConfigurationOrDateGreaterThanOrEqualTo: environment.Date,
    };

    this.$state = $state;
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      "/api/machines/MachineConfigurationSoftware"
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    //TODO: Add Missing colums
    this.columns = [
      columnDefinitionService.getSelectColDef({
        headerName: "Select",
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "SlotNumber",
        header: "Asset Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "SerialNumber",
      }),
      columnDefinitionService.getStringColDef({
        field: "Status",
        filter: new FilterProvider("Statue", $compile)
          .addFilter(
            "=",
            new OptionsFilter({
              displayName: "=",
              queryFieldNames: ["Status"],
              options: [
                {
                  display: "Decommissioned",
                  value: "Decommissioned",
                },
                {
                  display: "Floor",
                  value: "Floor",
                },
                {
                  display: "Warehoused",
                  value: "Warehoused",
                },
              ],
              includeNullValue: true,
            })
          )
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getDateColDef({
        field: "Date",
        header: "Project Date",
      }),
      columnDefinitionService.getStringColDef({
        field: "PrimaryTheme",
        header: "Primary Theme",
        filter: new FilterProvider("MachineConfigurationGameTheme", $compile)
          .defaultStringFilters()
          .getGridFilterFactory(),
      }),
      columnDefinitionService.getStringColDef({
        field: "PropertyName",
        header: "Property",
      }),
      columnDefinitionService.getStringColDef({
        field: "Location",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgramNumber",
        header: "Program Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "Software",
      }),
      columnDefinitionService.getStringColDef({
        field: "Version",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineAreaName",
        header: "Area",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineZoneName",
        header: "Zone",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineBankName",
        header: "Bank",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Position",
        header: "Position",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "CurrentConfiguration",
        header: "Current Configuration",
      }),
      columnDefinitionService.getDateColDef({
        field: "InServiceDate",
        header: "In Service Date",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineModelName",
        header: "Model",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineModelTypeName",
        header: "Model Type",
      }),
      columnDefinitionService.getDateColDef({
        field: "ManufacturersDate",
        header: "Manufacturers Date",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineManufacturerName",
        header: "Manufacturer",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineConfigurationOrder",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "Order",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineModelTypeId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineManufacturerId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineModelId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ChangeType",
        header: "Change Type",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineBankId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BaseMachineDenominationId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "BaseDenom",
        header: "Base Denom",
      }),
      columnDefinitionService.getNumberColDef({
        field: "BaseDenomValue",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "PrimaryMachineThemeId",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "MultiTheme",
        header: "Multi Theme",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "MultiDenom",
        header: "Multi Denom",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinPaybackPercentage",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackPercentage",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackWithContribution",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "HoldPercentage",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "VariableHoldPercentage",
        header: "Variable Hold Percentage",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxBet",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopCreditsAward",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopDollarAward",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "PaytableId",
        header: "Pay table Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "Paylines",
        header: "Pay lines",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineZoneId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineAreaId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "PropertyId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineGameCategoryId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineGameCategoryName",
        header: "Machine Game Category Name",
      }),
      columnDefinitionService.getNumberColDef({
        field: "JackpotLimit",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CreditLimit",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "PrinterLimit",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BillLimit",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "Roulette",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "MeterDelta",
        header: "Meter Delta",
      }),
      columnDefinitionService.getBooleanColDef({
        field: "TournamentEnabled",
        hide: true,
      }),
      columnDefinitionService.getBooleanColDef({
        field: "LeasedSoftware",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "IViewVersionId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewVersionName",
        header: "IView Version Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "AccountingMachineDenominationName",
        header: "Denomination Name",
      }),
      columnDefinitionService.getNumberColDef({
        field: "AccountingMachineDenominationValue",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewContent",
        header: "IView Content",
      }),
      columnDefinitionService.getStringColDef({
        field: "IViewOSVersion",
        header: "IView OS Version",
      }),
      columnDefinitionService.getStringColDef({
        field: "ROMSIGSoftwareName",
        header: "ROMSIG SoftwareName",
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterModel",
        header: "Printer Model",
      }),
      columnDefinitionService.getStringColDef({
        field: "BillValidatorModel",
        header: "Bill Validator Model",
      }),
      columnDefinitionService.getStringColDef({
        field: "Ownership",
        header: "Ownership",
      }),
      columnDefinitionService.getNumberColDef({
        field: "ChangeId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "AccountingDenominationId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineConfigurationId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Notes",
        header: "Notes",
      }),
      columnDefinitionService.getStringColDef({
        field: "GameTheme",
        header: "Game Theme",
      }),
      columnDefinitionService.getStringColDef({
        field: "WarehouseLocation",
        header: "Warehouse Location",
      }),
      columnDefinitionService.getNumberColDef({
        field: "BillValidatorCapacity",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "GameType",
        header: "Game Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "Topper",
        header: "Topper",
      }),
      columnDefinitionService.getStringColDef({
        field: "RouletteId",
        header: "Roulette Id",
      }),
      columnDefinitionService.getNumberColDef({
        field: "DailyFee",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CoinInPercentage",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinDaysNotification",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "NXPFirmware",
        header: "NXP Firm ware",
      }),
      columnDefinitionService.getStringColDef({
        field: "GenesisFirmware",
        header: "Genesis Firmware",
      }),
      columnDefinitionService.getStringColDef({
        field: "GMUDOCID",
        header: "GMUDOCID",
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterManufacturer",
        header: "Printer Manufacturer",
      }),
      columnDefinitionService.getStringColDef({
        field: "PrinterSerialNumber",
        header: "Printer Serial Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "BVSerialNumber",
        header: "BV Serial Number",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MainDoorMD5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MainDoorMD1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CPU5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CPU1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BellyDoorBVS5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "BellyDoorBVS1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashboxBVC5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashboxBVC1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashBoxDoorBVA5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "CashBoxDoorBVA1_1_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ElectricalBaseELE5_8",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "ElectricalBaseELE1_1_8",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "ContractNumber",
        header: "Contract Number",
      }),
      columnDefinitionService.getDateColDef({
        field: "ContractExpiryDate",
        header: "Contract Expiry Date",
      }),
      columnDefinitionService.getNumberColDef({
        field: "ProgressiveDefinitionId",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "LinkId",
        header: "Link Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProjectNumber",
        header: "Project Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveDefinitionName",
        header: "Progressive Definition Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveTypeName",
        header: "Progressive Type Name",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveControllerVersion",
        header: "Progressive Controller Version",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveControllerSerialNumber",
        header: "Progressive Controller Serial Number",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveSoftware1",
        header: "Progressive Software 1",
      }),
      columnDefinitionService.getStringColDef({
        field: "ProgressiveSoftware2",
        header: "Progressive Software 2",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineConfigurationId",
        hide: true,
      }),
    ];

    machineConfigurationCellClassService.styleColumns(this.columns, true);
  }

  gridSelectionChanged(data: any, selected: boolean) {
    const id = data.Id;
    const existingSelection = this.gridSelection.find((r) => r.Id === id);
    const existingSelectionIndex =
      existingSelection === undefined
        ? -1
        : this.gridSelection.indexOf(existingSelection);
    if (!selected && existingSelectionIndex > -1) {
      this.gridSelection.splice(existingSelectionIndex, 1);
      return;
    }
    if (selected && existingSelectionIndex === -1) {
      this.gridSelection.push(data);
    }
  }

  async showModal(template: string): Promise<any> {
    let modalInstance: angular.ui.bootstrap.IModalInstanceService | undefined =
      undefined;

    try {
      modalInstance = await this.$uibModal.open({
        template: template,
      });
    } catch {
      modalInstance?.dismiss();
    }

    return modalInstance?.result;
  }

  async SoftwareUpgrade(): Promise<void> {
    const softwares = this.gridSelection ?? [];
    if (softwares.length === 0) return;

    const hasMachineConfigurationWithMultipleSelectedSoftwares =
      this.hasMachineConfigurationWithMultipleSelectedSoftwares(softwares);

    if (hasMachineConfigurationWithMultipleSelectedSoftwares) {
      await this.showModal(
        require("!html-loader!./unableToUpdateModalTemplate.html").default
      );
      return;
    }

    if (this.hasMultipleProgramNumbers(softwares)) {
      const proceed = await this.showModal(
        require("!html-loader!./differentProgramNumbersModalTemplate.html")
          .default
      );
      if (!proceed) {
        return;
      }
    }

    return await this.$state.go(".SoftwareUpgrade", { softwares });
  }

  private hasMultipleProgramNumbers(
    softwares: MachineConfigurationSoftwareView[]
  ) {
    const programNumbers = softwares.reduce((result, next) => {
      result.add(next.ProgramNumber ?? "");
      return result;
    }, new Set<string>());

    return programNumbers.size > 1;
  }

  private hasMachineConfigurationWithMultipleSelectedSoftwares(
    softwares: MachineConfigurationSoftwareView[]
  ): boolean {
    let testResult = false;

    softwares.reduce((result, next) => {
      const machineConfigurationId = next.MachineConfigurationId ?? -1;

      if (result.has(machineConfigurationId)) {
        testResult = true;
      }

      result.add(machineConfigurationId);
      return result;
    }, new Set<number>());

    return testResult;
  }

  currentOrFutureConfigurationsOnlyChanged(
    currentConfigurationOrDateGreaterThanOrEqualTo: boolean
  ) {
    this.defaultQuery.CurrentConfigurationOrDateGreaterThanOrEqualTo =
      currentConfigurationOrDateGreaterThanOrEqualTo
        ? this.environment.Date
        : undefined;
  }

  selectedOnlyChanged(selectedOnly: boolean) {
    const selectedIds = this.gridSelection.map((s) => s.Id);
    this.defaultQuery.Ids = selectedOnly
      ? selectedIds.length == 0
        ? [-1]
        : selectedIds
      : undefined;
  }
}
